(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('custactCalcEdit', {
        templateUrl: 'views/components/views/custactCalcEdit/custactCalcEdit.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'modalService', 'utilityService', 'custactCalcEditService', 'custactCompsService', 'custactWorksService', 'economyService', 'rememberService', 'ttGridFactory', 'layoutService', 'translateService', function ($stateParams, stateService, modalService, utilityService, custactCalcEditService, custactCompsService, custactWorksService, economyService, rememberService, ttGridFactory, layoutService, translateService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let custactNo = $stateParams.custact_no;
            let onDestroy = [];

            let variableNames = {
                bg_custactcalcedit_main: ''
            };

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                tabletSize: layoutService.getMediaQueries().tablet,
                gridComponentsReady: false,
                gridSelectComponents: false,
                gridWorksReady: false,
                gridRelationsReady: false,
                bgMain: {
                    selected: 'CALC',
                    buttons: [
                        { id: 'CALC', label: 'custactcalcedit_mainbg_calc', color: 'primary', onClick: () => setMainView('CALC') },
                        { id: 'TEXT', label: 'custactcalcedit_mainbg_text', color: 'primary', onClick: () => setMainView('TEXT') },
                        { id: 'FUNCTIONS', label: 'custactcalcedit_mainbg_functions', color: 'primary', onClick: () => setMainView('FUNCTIONS') }
                    ]
                },
                bgItemsSelection: {
                    selected: 'C',
                    buttons: [
                        { id: 'C', label: 'custactcalc_materials', color: 'primary', onClick: () => vm.model.bgItemsSelection.selected = 'C' },
                        { id: 'W', label: 'custactcalc_work', color: 'primary', onClick: () => vm.model.bgItemsSelection.selected = 'W' },
                        { id: 'S', label: 'custactcalc_sum', color: 'primary', onClick: () => vm.model.bgItemsSelection.selected = 'S' }
                    ]
                },
                bgComponentSelection: {
                    selected: 'S',
                    buttons: [
                        { id: 'S', label: 'custactcomps_selected', color: 'primary', onClick: () => vm.model.bgComponentSelection.selected = 'S' },
                        { id: 'A', label: 'custactcomps_all', color: 'primary', onClick: () => vm.model.bgComponentSelection.selected = 'A' }
                    ]
                },
                bgSumSelection: {
                    selected: 'PCS',
                    buttons: [
                        { id: 'PCS', label: 'custactcalcedit__calc_pcs', color: 'primary', onClick: () => vm.model.bgSumSelection.selected = 'PCS' },
                        { id: 'SUM', label: 'custactcalcedit_calc_sum', color: 'primary', onClick: () => vm.model.bgSumSelection.selected = 'SUM' },
                        { id: 'SUMWORK', label: 'custactcalcedit_calc_sumwork', color: 'primary', onClick: () => vm.model.bgSumSelection.selected = 'SUMWORK' }
                    ]
                },
                bgNumberTypeSelection: {
                    selected: 'NT_TOTAL',
                    buttons: [
                        { id: 'NT_TOTAL', label: 'custactcalcedit_nt_total', color: 'primary', onClick: () => vm.model.bgNumberTypeSelection.selected = 'NT_TOTAL' },
                        { id: 'NT_MATERIAL', label: 'custactcalcedit_nt_material', color: 'primary', onClick: () => vm.model.bgNumberTypeSelection.selected = 'NT_MATERIAL' },
                        { id: 'NT_WORK', label: 'custactcalcedit_nt_work', color: 'primary', onClick: () => vm.model.bgNumberTypeSelection.selected = 'NT_WORK' }
                    ]
                },
                custactNoBasisButtons: [
                    { id: 'edit', icon: 'glyphicon glyphicon-edit', color: 'primary', type: 'primary', onClick: () => stateService.go('workdetails', { custact_no: vm.model.edit.custact_no_basis }) },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('custactcalcedit', { custact_no: vm.model.edit.custact_no_basis }) }
                ],
                editProductButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_id }) }
                ],
                createProductButtons: [
                    { id: 'new', icon: 'fa fa-solid fa-plus', color: 'primary', type: 'primary', onClick: () => goToProductCreate() }
                ],
                edit: {},
                calcSum: {},
                itemsListComponents: [],
                itemsListJobs: [],
                itemsListWorkCosts: [],
                refreshingPrices: false,
                fetchingWorkTime: false,
                updatingFromBasics: false,
                lockedSave: false,
                lockedDelete: false
            };

            vm.gridComponents = new ttGridFactory({
                rememberId: 'w_custactcalcedit_custactcomp_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });

            vm.gridSelectComponents = new ttGridFactory({
                rememberId: 'w_custactcalcedit_custactcomp_select_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });
            
            vm.gridWorks = new ttGridFactory({
                rememberId: 'w_custactcalcedit_custactwork_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });

            vm.gridRelations = new ttGridFactory({
                rememberId: 'custactcalc_relations_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });

            // #endregion VARIABLES & DEFINITIONS

            // #region BUTTON RADIO SET VALUE FUNCTION

            function setMainView(id) {
                vm.model.bgMain.selected = vm.model.edit.bg_custactcalcedit_main = id;
            }

            // #endregion BUTTON RADIO SET VALUE FUNCTION

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.edit = (await economyService.getCustomerActivity({ custact_no: custactNo }))[0];
                
                setMainView(vm.model.edit.bg_custactcalcedit_main);
                
                if (vm.model.bgItemsSelection.selected === 'C') {
                    if (vm.model.tabletSize.matches === true) {
                        if (vm.model.bgComponentSelection.selected === 'S') loadGridComponents();
                        if (vm.model.bgComponentSelection.selected === 'A') loadGridSelectComponents();
                    } else {
                        loadComponents();
                    }
                }

                if (vm.model.bgItemsSelection.selected === 'W') {
                    if (vm.model.tabletSize.matches === true) {
                        loadGridWorks();
                    } else {
                        loadJobs();
                    }
                }

                loadGridRelations();

                if (vm.model.bgItemsSelection.selected === 'S' && vm.model.bgSumSelection.selected === 'SUMWORK') loadWorkCosts();
            }

            async function loadComponents() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                if (utilityService.validateParmsValue(vm.model.bgComponentSelection.selected) !== true) return;

                vm.model.itemsListComponents = await custactCompsService.listComponents({
                    custact_no: vm.model.edit.custact_no,
                    select_status: vm.model.bgComponentSelection.selected
                });
            }

            async function loadJobs() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                vm.model.itemsListJobs = await custactWorksService.listJobs({ custact_no: vm.model.edit.custact_no });
            }

            async function loadWorkCosts() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                vm.model.itemsListWorkCosts = await custactCalcEditService.listWorkCosts({ custact_no: vm.model.edit.custact_no });
            }

            function retrieveCalcSum() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.price_locval) !== true) return;
                if (utilityService.validateParmsValue(vm.model.bgSumSelection.selected) !== true) return;

                return custactCalcEditService.getCalcSum({
                    custact_no: vm.model.edit.custact_no,
                    retrievetype: 'child',
                    include_top: '1',
                    price_locval: vm.model.edit.price_locval,
                    calctype: vm.model.bgSumSelection.selected
                }).then((response) => vm.model.calcSum = response[0]);
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGridComponents() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                
                vm.gridComponents.dataTask.loadData = {
                    method: 2849,
                    parameters: vm.model.edit
                };

                vm.model.gridComponentsReady = true;

                if (vm.gridComponents.gridfunc !== null) vm.gridComponents.gridfunc.read();
            }

            async function loadGridSelectComponents() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                
                vm.gridSelectComponents.dataTask.loadData = {
                    method: 2850,
                    parameters: vm.model.edit
                };

                vm.model.gridSelectComponentsReady = true;

                if (vm.gridSelectComponents.gridfunc !== null) vm.gridSelectComponents.gridfunc.read();
            }

            async function loadGridWorks() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                
                vm.gridWorks.dataTask.loadData = {
                    method: 2851,
                    parameters: vm.model.edit
                };

                vm.model.gridWorksReady = true;

                if (vm.gridWorks.gridfunc !== null) vm.gridWorks.gridfunc.read();
            }

            async function loadGridRelations() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
                
                vm.gridRelations.dataTask.loadData = {
                    method: 2848,
                    parameters: vm.model.edit
                };

                vm.model.gridRelationsReady = true;

                if (vm.gridRelations.gridfunc !== null) vm.gridRelations.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'bg_custactcalcedit_main':
                            variableNames[key] = key;
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'bg_custactcalcedit_main':
                        if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

                        variableValue = vm.model.edit[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RECALCULATION FUNCTION

            vm.recalcAmoutOrdVal = function () {
                vm.model.edit.amount_ordval = (vm.model.edit.quantity * vm.model.edit.price_ordval) - (vm.model.edit.quantity * vm.model.edit.price_ordval * vm.model.edit.linediscount_pst / 100);
            };

            // #endregion RECALCULATION FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                custactCalcEditService.saveObj(vm.model.edit).then(() => {
                    vm.model.lockedSave = false;

                    retrieveCalcSum();

                    if (vm.model.bgItemsSelection.selected === 'S' && vm.model.bgSumSelection.selected === 'SUMWORK') loadWorkCosts();
                }, () => vm.model.lockedSave = false);
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    custactCalcEditService.deleteItem({ custact_no: vm.model.edit.custact_no }).then(() => {
                        vm.model.lockedDelete = false;
                        stateService.back();
                    }, () => vm.model.lockedDelete = false);
                }, () => vm.model.lockedDelete = false);
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region UPDATE PRICE BUTTON FUNCTION
            
            vm.refreshPricesChanges = function () {
                vm.model.refreshingPrices = true;

                custactCalcEditService.updatePrices({ custact_no: vm.model.edit.custact_no }).then(function (response) {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.refreshingPrices = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.refreshingPrices = false;

                        if (vm.model.bgItemsSelection.selected === 'C') {
                            if (vm.model.tabletSize.matches === true) {
                                if (vm.model.bgComponentSelection.selected === 'S') loadGridComponents();
                                if (vm.model.bgComponentSelection.selected === 'A') loadGridSelectComponents();
                            } else {
                                loadComponents();
                            }
                        } else if (vm.model.bgItemsSelection.selected === 'W') {
                            if (vm.model.tabletSize.matches === true) {
                                loadGridWorks();
                            } else {
                                loadJobs();
                            }
                        } else if (vm.model.bgItemsSelection.selected === 'S') {
                            retrieveCalcSum();
                        }
                    }
                });
            };

            // #endregion UPDATE PRICE BUTTON FUNCTION

            // #region GET WORK TIME PROCEDURE FUNCTION CALL

            vm.fetchWorkTimeChanges = function () {
                vm.model.fetchingWorkTime = true;

                custactCalcEditService.getWorkTime({ custact_no: vm.model.edit.custact_no }).then(function (response) {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.fetchingWorkTime = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.fetchingWorkTime = false;

                        retrieveCalcSum();

                        if (vm.model.bgItemsSelection.selected === 'W') {
                            if (vm.model.tabletSize.matches === true) {
                                loadGridWorks();
                            } else {
                                loadJobs();
                            }
                        }
                    }
                });
            };

            // #endregion GET WORK TIME PROCEDURE FUNCTION CALL

            // #region BUTTON UPDATE FROM BASICS PROCEDURE FUNCTION CALL

            vm.updateFromBasicsChanges = function () {
                if (vm.model.edit.nbr_of_childs > 0) {
                    modalService.confirm({
                        type: 'danger',
                        title: translations.confirm_title,
                        message: translations.confirm_message,
                        okLabel: translations.confirm_ok_label,
                        cancelLabel: translations.confirm_cancel_label
                    }).then(function () {
                        vm.model.updatingFromBasics = true;

                        custactCalcEditService.updateFromBasicsObj({ custact_no: vm.model.edit.custact_no }).then(function (response) {
                            if (response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.updatingFromBasics = false;
                                        }
                                    }]
                                });
                            } else {
                                vm.model.updatingFromBasics = false;

                                if (vm.model.bgItemsSelection.selected === 'C') {
                                    if (vm.model.tabletSize.matches === true) {
                                        if (vm.model.bgComponentSelection.selected === 'S') loadGridComponents();
                                        if (vm.model.bgComponentSelection.selected === 'A') loadGridSelectComponents();
                                    } else {
                                        loadComponents();
                                    }
                                } else if (vm.model.bgItemsSelection.selected === 'W') {
                                    if (vm.model.tabletSize.matches === true) {
                                        loadGridWorks();
                                    } else {
                                        loadJobs();
                                    }
                                } else if (vm.model.bgItemsSelection.selected === 'S') {
                                    retrieveCalcSum();
                                }
                            }
                        });
                    }, function () {
                        vm.model.updatingFromBasics = false;
                    });
                } else {
                    vm.model.updatingFromBasics = true;

                    custactCalcEditService.updateFromBasicsObj({ custact_no: vm.model.edit.custact_no }).then(function (response) {
                        if (response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                        vm.model.updatingFromBasics = false;
                                    }
                                }]
                            });
                        } else {
                            vm.model.updatingFromBasics = false;

                            if (vm.model.bgItemsSelection.selected === 'C') {
                                if (vm.model.tabletSize.matches === true) {
                                    if (vm.model.bgComponentSelection.selected === 'S') loadGridComponents();
                                    if (vm.model.bgComponentSelection.selected === 'A') loadGridSelectComponents();
                                } else {
                                    loadComponents();
                                }
                            } else if(vm.model.bgItemsSelection.selected === 'W') {
                                if (vm.model.tabletSize.matches === true) {
                                    loadGridWorks();
                                } else {
                                    loadJobs();
                                }
                            } else if (vm.model.bgItemsSelection.selected === 'S') {
                                retrieveCalcSum();
                            }
                        }
                    });
                }
            };

            // #endregion BUTTON UPDATE FROM BASICS PROCEDURE FUNCTION CALL

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'custactcomp':
                        go({
                            custact_no: vm.model.edit.custact_no,
                            custactcomp_keyno: '0'
                        });
                        break;
                    case 'custactwork':
                        go({
                            custact_no: vm.model.edit.custact_no,
                            custactwork_keyno: '0'
                        });
                        break;
                    default:
                        break;
                }
            };

            function goToProductCreate() {
                let variableNameNewProduct = 'w_custactcalcedit.newproduct';

                rememberService.remember(variableNameNewProduct, '1').then(() => {
                    stateService.go('productcreate', {
                        argtype: 'custact_no',
                        argvalue: vm.model.edit.custact_no
                    });
                });
            }

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onQuantityChanged = function (value) {
                vm.model.edit.quantity = value;

                if (value) {
                    vm.recalcAmoutOrdVal(value);
                }
            }

            vm.onPriceOrdvalChanged = function (value) {
                vm.model.edit.price_ordval = value;

                if (value) {
                    vm.recalcAmoutOrdVal(value);
                }
            }

            vm.onLinediscountPstChanged = function (value) {
                vm.model.edit.linediscount_pst = value;

                if (value) {
                    vm.recalcAmoutOrdVal(value);
                }
            }

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region TOGGLE LIST SINGLE FUNCTION

            vm.toggleChosenComponents = function (item) {
                if (item.item_id === '0' || item.item_id === '-1') return;

                if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                    item.item_glyphicon_color = 'black';
                    item.item_glyphicon = 'glyphicon-unchecked';
                } else {
                    item.item_is_selected = '1';
                    item.item_glyphicon_color = 'green';
                    item.item_glyphicon = 'glyphicon-check';
                }
            };

            // #endregion TOGGLE LIST SINGLE FUNCTION

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgMain = function (value) {
                vm.model.bgMain.selected = value;
                vm.model.edit.bg_custactcalcedit_main = vm.model.bgMain.selected;
                rememberFunc('bg_custactcalcedit_main');
            };

            vm.selectBgItemsSelection = function (value) {
                vm.model.bgItemsSelection.selected = value;

                if ((vm.model.bgItemsSelection.selected === 'S' && vm.model.bgSumSelection.selected !== '') && vm.model.edit.price_locval > '') retrieveCalcSum();

                if (vm.model.bgItemsSelection.selected === 'W') {
                    if (vm.model.tabletSize.matches === true) {
                        loadGridWorks();
                    } else {
                        loadJobs();
                    }
                }
            };

            vm.selectBgComponentSelection = function (value) {
                vm.model.bgComponentSelection.selected = value;

                if (vm.model.bgItemsSelection.selected === 'C') {
                    if (vm.model.tabletSize.matches === true) {
                        if (vm.model.bgComponentSelection.selected === 'S') loadGridComponents();
                        if (vm.model.bgComponentSelection.selected === 'A') loadGridSelectComponents();
                    } else {
                        loadComponents();
                    }
                }
            };

            vm.selectBgSumSelection = function (value) {
                vm.model.bgSumSelection.selected = value;

                if ((vm.model.bgItemsSelection.selected === 'S' && vm.model.bgSumSelection.selected !== '') && vm.model.edit.price_locval > '') retrieveCalcSum();
                if (vm.model.bgItemsSelection.selected === 'S' && vm.model.bgSumSelection.selected === 'SUMWORK') loadWorkCosts();
            };

            vm.selectBgNumberTypeSelection = function (value) {
                vm.model.bgNumberTypeSelection.selected = value;
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region ON WINDOW RESIZE FUNCTION

            async function onWindowResize() {
                if (vm.model.tabletSize.matches === true) {
                    if (vm.model.bgItemsSelection.selected === 'C') {
                        if (vm.model.bgComponentSelection.selected === 'S') loadGridComponents();
                        if (vm.model.bgComponentSelection.selected === 'A') loadGridSelectComponents();
                    }

                    if (vm.model.bgItemsSelection.selected === 'W') loadGridWorks();
                } else {
                    loadComponents();

                    if (vm.model.bgItemsSelection.selected === 'W') loadJobs();
                }
            }

            // #endregion ON WINDOW RESIZE FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();

            	window.addEventListener('resize', onWindowResize);
            	onWindowResize();
            };

            // #endregion ON INIT FUNCTION

            // #region DESTROY FUNCTION

            vm.$onDestroy = function () {
            	window.removeEventListener('resize', onWindowResize);

            	onDestroy.forEach((fn) => {
            		if (typeof fn === 'function') fn();
            	});
            };

            // #endregion DESTROY FUNCTION

        }]
    });
})();
